import api from './api';

// const API_URL = process.env.REACT_APP_API_URL || 'http://13.233.6.224/api';
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Create axios instance with default config
// const inventoryAPI = axios.create({
//   baseURL: `${API_URL}/inventory`,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//     'Accept': 'application/json',
//   },
// });

// // Response interceptor
// inventoryAPI.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('user');
//       localStorage.removeItem('isAuthenticated');
//     }
//     return Promise.reject(error);
//   }
// );

const inventoryAPI = {
  get: (url, config) => api.get(`/inventory${url}`, config),
  post: (url, data, config) => api.post(`/inventory${url}`, data, config),
  put: (url, data, config) => api.put(`/inventory${url}`, data, config),
  delete: (url, config) => api.delete(`/inventory${url}`, config),
  interceptors: api.interceptors
};

export const inventoryService = {
  // Get all products
  getProducts: async (params = {}) => {
    const response = await inventoryAPI.get('/products', { params });
    return response.data;
  },

  // Get product by ID
  getProductById: async (productId) => {
    const response = await inventoryAPI.get(`/products/${productId}`);
    return response.data;
  },

  // Create product
  createProduct: async (productData) => {
    const response = await inventoryAPI.post('/products', productData);
    return response.data;
  },

  // Update product
  updateProduct: async (productId, productData) => {
    const response = await inventoryAPI.put(`/products/${productId}`, productData);
    return response.data;
  },

  // Delete product
  deleteProduct: async (productId) => {
    const response = await inventoryAPI.delete(`/products/${productId}`);
    return response.data;
  },

  // Get categories
  getCategories: async () => {
    const response = await inventoryAPI.get('/categories');
    return response.data;
  },

  // Get product meters
  getProductMeters: async (productId, params = {}) => {
    const response = await inventoryAPI.get(`/products/${productId}/meters`, { params });
    return response.data;
  },

  // Add meter to product
  addMeterToProduct: async (productId, meterData) => {
    const response = await inventoryAPI.post(`/products/${productId}/meters`, meterData);
    return response.data;
  },

  // Get meter assignment data
  getMeterAssignmentData: async (params = {}) => {
    const response = await inventoryAPI.get('/meter-assignment-data', { params });
    return response.data;
  },

  // Get products for dropdown (model numbers)
  getProductsForDropdown: async () => {
    const response = await inventoryAPI.get('/products-dropdown');
    return response.data;
  }
};

export default inventoryService;

